import { render } from "./WarningInfo.vue?vue&type=template&id=e1832f4a"
import script from "./WarningInfo.vue?vue&type=script&lang=js"
export * from "./WarningInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__